"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../../Common/CommonBaseError");
class EventReceiver {
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
    static from(id, name) {
        return new EventReceiver(id, name);
    }
    toString() { return JSON.stringify(this); }
}
//代表Service的Id
EventReceiver.SERVICE = new EventReceiver("cda0297a-8d10-4f1d-8f47-3e770f0908f1", "SERVICE");
//代表Client的Id，在Service端代表連接上來的Client，在手機網頁端，代表UI
EventReceiver.CLIENT = new EventReceiver("269fe910-6053-4540-a4ed-d05e3ac95a6c", "CLIENT");
EventReceiver.Nobody = new EventReceiver("", "");
exports.EventReceiver = EventReceiver;
exports.EventHubErrorName = "EventHubError";
class EventHubError extends CommonBaseError_1.CommonBaseError {
}
exports.EventHubError = EventHubError;
//# sourceMappingURL=IEventHub.js.map